import React, { useEffect, useState } from "react";
import "./Dashboard_main.css";
import { Link } from "react-router-dom";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { ProgressBar } from "react-bootstrap";
import { GET } from "../../utils/Methods";
import { AgCharts } from "ag-charts-react";
import { BarChart } from "@mui/x-charts/BarChart";

import HeatTransport from "./dash-map-transport/Table";
import HeatCab from "./dash_map_cab/Table";
import { GetUserInfo } from "../../features/auth/Slice";
import { useDispatch, useSelector } from "react-redux";

const Dashboard_main = () => {
  const dispatch = useDispatch();

  const [dashboard, setDashboard] = useState("");
  const [dashboardCircleChart, setDashboardCirclechart] = useState([]);
  const [dashboardPieChart, setDashboardCPieChart] = useState([]);

  const getAllDashboard = async () => {
    try {
      const res = await GET(`/admin/dashboard`);
      if (res?.data?.success) {
        setDashboard(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching dashboard:", error);
    }
  };

  const getAllcirclechartDashboard = async () => {
    try {
      const res = await GET(`/admin/dashboard-graph/piechart`);
      if (res?.data?.success) {
        const chartData = res.data.data.chartData;
        setDashboardCirclechart(chartData);
      }
    } catch (error) {
      console.error("Error fetching pie chart data:", error);
    }
  };

  const getAllPieDashboard = async () => {
    try {
      const res = await GET(`/admin/dashboard-graph/circlechart`);
      if (res?.data?.success) {
        setDashboardCPieChart(res.data.data.chartData);
      }
    } catch (error) {
      console.error("Error fetching circle chart data:", error);
    }
  };

  useEffect(() => {
    getAllDashboard();
    getAllcirclechartDashboard();
    getAllPieDashboard();
  }, []);

  const user = useSelector((state) => state.auth?.user_info);

  console.log(user, "user");

  useEffect(() => {
    dispatch(GetUserInfo());
  }, [dispatch]);

  const xLabels = dashboardPieChart.map((item) => item.label);
  const pData = dashboardPieChart.map((item) => Number(item.totalIncome));
  return (
    <section className="Dashboard_main_sec">
      <div className="innersectionflex">
        <div className="countrybox">
          <div className="section_box">
            <div className="row">
              <div className="col-lg-3 col-md-6 mb-3">
                <Link to={user?.role_id == 1 ? { pathname: "/customer" } : "/"}>
                  <div className="Dashboard_box_holder">
                    <div className="image-head">
                      <h4>Total Customers</h4>
                      <img
                        src="/assets/images/dashboard-icon/customer.png"
                        alt="icon"
                        className="icon"
                      />{" "}
                    </div>

                    <h1>{dashboard?.customerCount}</h1>
                  </div>
                </Link>
              </div>

              <div className="col-lg-3 col-md-6 mb-3">
                <Link
                  to={
                    user?.role_id == 1
                      ? { pathname: "/driver", search: "?vehicleType=Cab" }
                      : "/"
                  }
                >
                  <div className="Dashboard_box_holder">
                    <div className="image-head">
                      <h4>Total Cab Drivers</h4>
                      <img
                        src="/assets/images/dashboard-icon/cab-driver.png"
                        alt="icon"
                        className="icon"
                      />{" "}
                    </div>
                    <h1>{dashboard?.TotalCabDriver}</h1>
                  </div>
                </Link>
              </div>

              <div className="col-lg-3 col-md-6 mb-3">
                <Link
                  to={
                    user?.role_id == 1
                      ? {
                          pathname: "/driver",
                          search: "?vehicleType=Transport",
                        }
                      : "/"
                  }
                >
                  <div className="Dashboard_box_holder">
                    <div className="image-head">
                      <h4>Total Transport Drivers</h4>
                      <img
                        src="/assets/images/dashboard-icon/transport-driver.png"
                        alt="icon"
                        className="icon"
                      />{" "}
                    </div>
                    <h1>{dashboard?.TotalTransportDriver}</h1>
                  </div>
                </Link>
              </div>

              <div className="col-lg-3 col-md-6 mb-3">
                <Link
                  to={
                    user?.role_id == 1
                      ? { pathname: "/driver", search: "?vehicleType=Share" }
                      : "/"
                  }
                >
                  <div className="Dashboard_box_holder">
                    <div className="image-head">
                      <h4>Total Share Drivers</h4>
                      <img
                        src="/assets/images/dashboard-icon/carshare.png"
                        alt="icon"
                        className="icon"
                      />{" "}
                    </div>
                    <h1>{dashboard?.TotalShareDriverDriver}</h1>
                  </div>
                </Link>
              </div>

              <div className="col-lg-3 col-md-6 mb-3">
                <Link
                  to={user?.role_id == 1 ? { pathname: "/cab-booking" } : "/"}
                >
                  <div className="Dashboard_box_holder">
                    <div className="image-head">
                      <h4>Total Cab Bookings</h4>
                      <img
                        src="/assets/images/dashboard-icon/cab-bookin.png"
                        alt="icon"
                        className="icon"
                      />{" "}
                    </div>
                    <h1>{dashboard?.TotalCabBooking}</h1>
                  </div>
                </Link>
              </div>

              <div className="col-lg-3 col-md-6 mb-3">
                <Link to={user?.role_id == 1 ? { pathname: "/booking" } : "/"}>
                  <div className="Dashboard_box_holder">
                    <div className="image-head">
                      <h4>Total Transport Bookings</h4>
                      <img
                        src="/assets/images/dashboard-icon/transport-booking.png"
                        alt="icon"
                        className="icon"
                      />{" "}
                    </div>
                    <h1>{dashboard?.TotalTransportBooking}</h1>
                  </div>
                </Link>
              </div>

              <div className="col-lg-3 col-md-6 mb-3">
                <Link
                  to={
                    user?.role_id == 1
                      ? {
                          pathname: "/share-booking",
                        }
                      : "/"
                  }
                >
                  <div className="Dashboard_box_holder">
                    <div className="image-head">
                      <h4>Total Share Bookings</h4>
                      <img
                        src="/assets/images/dashboard-icon/sharing-book.png"
                        alt="icon"
                        className="icon"
                      />{" "}
                    </div>
                    <h1>{dashboard?.TotalShareBooking}</h1>
                  </div>
                </Link>
              </div>
              <div className="col-lg-3 col-md-6 mb-3">
                <Link
                  to={
                    user?.role_id == 1
                      ? {
                          pathname: "/user-gift-table",
                        }
                      : "/"
                  }
                >
                  <div className="Dashboard_box_holder">
                    <div className="image-head">
                      <h4>Total Gifts Achieved</h4>
                      <img
                        src="/assets/images/dashboard-icon/total-gifts.png"
                        alt="icon"
                        className="icon"
                      />{" "}
                    </div>
                    <h1>{dashboard?.TotalGift}</h1>
                  </div>
                </Link>
              </div>
              <div className="col-lg-3 col-md-6 mb-3">
                <Link
                  to={
                    user?.role_id == 1
                      ? {
                          pathname: "/user-recharge-table",
                          search: "?status=1",
                        }
                      : "/"
                  }
                >
                  <div className="Dashboard_box_holder">
                    <div className="image-head">
                      <h4>Total Active Recharge</h4>
                      <img
                        src="/assets/images/dashboard-icon/total-active-recharge.png"
                        alt="icon"
                        className="icon"
                      />{" "}
                    </div>
                    <h1>{dashboard?.TotalRechargeActive}</h1>
                  </div>
                </Link>
              </div>
            </div>

            <div className="charts_section">
              <div className="row">
                <div className="col-lg-6 mb-4">
                  <div className="chart_div">
                    <div className="chartheading">
                      <h6 className="heading">Total Driver Income</h6>
                    </div>

                    <AgCharts
                      options={{
                        title: {
                          text: "",
                        },
                        series: [
                          {
                            type: "pie",
                            angleKey: "income",
                            labelKey: "name",
                            calloutLabel: {
                              enabled: true,
                            },
                            tooltip: {
                              renderer: ({ datum }) =>
                                `${datum.name}: ₹${Number(datum.income).toFixed(
                                  2,
                                )}`,
                            },
                            data: dashboardCircleChart,
                          },
                        ],
                      }}
                    />
                  </div>
                </div>
                <div className="col-lg-6 mb-4">
                  <div className="chart_div">
                    <div className="chartheading">
                      <h6 className="heading">Monthly Income</h6>
                    </div>
                    <BarChart
                      height={300}
                      series={[
                        {
                          data: pData,
                          id: "pvId",
                          yAxisId: "leftAxisId",
                        },
                      ]}
                      xAxis={[{ data: xLabels }]}
                      yAxis={[
                        { id: "leftAxisId", width: 50 },
                        { id: "rightAxisId", position: "right" },
                      ]}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              {/* <div className="col-lg-6 mb-4">
                <HeatTransport />
              </div> */}
              <div className="col-lg-12 mb-4">
                <HeatCab />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Dashboard_main;
